import React from "react";
import { Navigate } from "react-router-dom";

/**
 * `/pricing` — redirect shell (iter57).
 *
 * The public pricing menu splits into `/pricing/clubs` and
 * `/pricing/vendors`. If a visitor lands on `/pricing` directly (from an
 * old bookmark or an external link), send them to the Clubs page since
 * that's the primary revenue driver.
 */
export default function PricingPage() {
  return <Navigate to="/pricing/clubs" replace />;
}
